import { FC } from 'react';
import styled from 'styled-components';
import { motion, Variants } from 'motion/react';
import { SmallBold } from '@comeon/ui';
import Icon, { ICON_BOTTOM } from '~/components/icon';
import SportsbookTextKeys, { SportsbookTranslations } from '../../sportsbook-text-keys';

const Wrapper = styled.div`
	display: flex;
	flex: 1;
	padding: 12px;
	align-items: center;
	justify-content: center;
	gap: 5px;
	cursor: pointer;
`;

const MotionIconWrapper = styled(motion.span)`
	width: 16px;
	height: 16px;
	display: flex;
	align-items: center;
`;

const CollapseIconDown = styled(Icon).attrs({ type: ICON_BOTTOM })`
	&& {
		color: var(--main-primary);
		fill: var(--main-primary);
	}
`;

const variantsRotate: Variants = {
	down: { rotate: '0deg' },
	up: { rotate: '180deg' }
};

type Props = {
	className?: string;
	label?: string;
	isExpanded: boolean;
	translations: SportsbookTranslations;
	onClick: () => void;
};

const SportsbookShowMoreToggle: FC<Props> = ({ className, label, isExpanded, translations, onClick }) => {
	return (
		<Wrapper className={className} onClick={onClick}>
			<SmallBold>
				{label ||
					(isExpanded
						? translations[SportsbookTextKeys.TOGGLE_SHOW_LESS]
						: translations[SportsbookTextKeys.TOGGLE_SHOW_MORE])}
			</SmallBold>
			<MotionIconWrapper
				initial="down"
				variants={variantsRotate}
				animate={isExpanded ? 'up' : 'down'}
				transition={{
					x: { type: 'spring', stiffness: 100, damping: 100 }
				}}
			>
				<CollapseIconDown type={ICON_BOTTOM} />
			</MotionIconWrapper>
		</Wrapper>
	);
};

export default SportsbookShowMoreToggle;
